<div class="panel-group" id="accordion">
  <app-report-detail-section [section]="'recommendation'" [title]="'Recommendation'"
  [allExpandState]="allExpandState"></app-report-detail-section>
  <div #section id="recommendation" class="panel-collapse collapse">
    <div class="panel-body ">
      <app-aa-spinner [loading]="isLoading"></app-aa-spinner>
      @if (!isLoading) {
        <div>
          @for (reportRecommendation of recommendation  | SortByTimeStampPipe : 'CreateDate'; track reportRecommendation) {
            <div
              class="recomm">
              <div class="description-timestamp">{{reportRecommendation.createDate |
                date:'MM/dd/yyyy'}} at {{reportRecommendation.createDate |
              date:'shortTime'}}</div>
              <div class="description-text">{{reportRecommendation.narrativeText}}</div>
            </div>
          }
          @if (!recommendation.length > 0) {
            <label> No Recommendation Provided</label>
          }
          @if (hideAddButton) {
            <app-add-section-inline [title]="'Add recommendation'" [btnTitle]="'Save'"
            (onSave)="onSave($event)"> </app-add-section-inline>
          }
        </div>
      }
    </div>
  </div>
